import React from "react";
import { Link } from "react-router-dom";

class Filter extends React.Component {
  state = {
    isFilterOpen: false,
    neededType: null
  };

  handleFilterOpen = () => {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  };

  handleFilter = () => {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  };

  render() {
    return (
      <div className="filter-wrapper">
        <div className="filter-menu">
          <div className="title-container">
            <p className="filter-title">Kategorie:</p>
          </div>
          <button className="filter-btn" onClick={this.handleFilterOpen}>
            {this.props.category || "vybrat"}
          </button>

          <ul
            className={
              this.state.isFilterOpen
                ? "nav-filter-links show-filter"
                : "nav-filter-links"
            }
          >
            <li className="filter-item">
              <Link
                onClick={this.handleFilter}
                className="kitchen"
                to="/projekty/kuchyne"
              >
                kuchyně
              </Link>
            </li>
            <li className="filter-item">
              <Link
                onClick={this.handleFilter}
                className="room"
                to="/projekty/pokoje"
              >
                pokoje
              </Link>
            </li>
            <li className="filter-item">
              <Link
                onClick={this.handleFilter}
                className="restaurant"
                to="/projekty/loznice"
              >
                ložnice
              </Link>
            </li>
            <br />
            <li className="filter-item">
              <Link
                onClick={this.handleFilter}
                className="furniture"
                to="/projekty/predsine"
              >
                předsíně
              </Link>
            </li>
            <li className="filter-item">
              <Link
                onClick={this.handleFilter}
                className="reception"
                to="/projekty/koupelny"
              >
                koupelnový nábytek
              </Link>
            </li>
            <li className="filter-item">
              <Link
                onClick={this.handleFilter}
                className="office"
                to="/projekty/ostatni"
              >
                ostatní
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Filter;

// kliknu na filter-item
//

// handleFilterK = (neededType = "") => {
//     this.setState({ isFilterOpen: !this.state.isFilterOpen })
//     this.setState({ neededType: "kitchen" })
// };

// handleFilterR = (neededType = "") => {
//     this.setState({ isFilterOpen: !this.state.isFilterOpen })
//     this.setState({ neededType: "room" })
// };

// handleFilterRe = (neededType = "") => {
//     this.setState({ isFilterOpen: !this.state.isFilterOpen })
//     this.setState({ neededType: "restaurant" })
// };

// handleFilterF = (neededType = "") => {
//     this.setState({ isFilterOpen: !this.state.isFilterOpen })
//     this.setState({ neededType: "furniture" })
// };

// handleFilterRec = (neededType = "") => {
//     this.setState({ isFilterOpen: !this.state.isFilterOpen })
//     this.setState({ neededType: "furniture" })
// };

// handleFilterO = (neededType = "") => {
//     this.setState({ isFilterOpen: !this.state.isFilterOpen })
//     this.setState({ neededType: "office" })
// };

// myCallback = (neededType = "") => {
//     neededType = "kitchen";
//     this.props.callbackFromParent(neededType);
// }



// WEBPACK FOOTER //
// ./src/components/Filter.js